

<div class=" refund_wrapper refund_another">
<span mat-button (click)="onNoClick()" class="close-btn-modal material-icons">
  close
</span>
  <!-- <div class="new-container"> -->
    <div class="dialoghead assignAdvo_wrapper">
      <h1>Add Media Form</h1>
    </div>
    <mat-dialog-content>
    <div class="subwrapper ">
      <div class="formStyle user-form">
        <mat-card-content
          class="addEditPageWrapper practice_form_style form_title_style"
        >
          <div class="AddEditBlog taxonomies_formstyle">
            <div class="addEditForm">
              <ng-container *ngIf="this.userformdata">
                <lib-showform
                  [formdata]="userformdata"
                  [formfieldrefresh]="formfieldrefresh"
                  [formfieldrefreshdata]="formfieldrefreshdata"
                  (onFormFieldChange)="listenFormFieldChange($event)"
                 
                >
                </lib-showform>
              </ng-container>
                  <mat-progress-bar *ngIf="loader" mode="indeterminate"></mat-progress-bar>

              
            </div>
          </div>
        </mat-card-content>
      </div>
    </div>
  </mat-dialog-content>
  <!-- </div> -->
</div>
